<template>
  <div class="panel-card" :style="panelStyle">
    <div class="header" @click="toggleCollapse" :style="headerStyle">
      <slot name="header"></slot>
    </div>
    <div class="content-wrapper" :style="wrapperStyle">
      <div ref="content" v-on="collapseOnContentClick ? {click: toggleCollapse} : null" :style="contentStyle">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PanelCard",
  props: {
    collapsible: {
      type: Boolean,
      default: false
    },
    collapsed: {
      type: Boolean,
      default: false
    },
    collapseOnContentClick: {
      type: Boolean,
      default: false
    },
    vPad: {
      type: Number,
      optional: true,
    },
    hPad: {
      type: Number,
      optional: true,
    },
    size: {
      Type: String,
      default: 'small',
      validator: (v) => ['small', 'big'].includes(v)
    }
  },

  data() {
    return {
      isOpen: !this.collapsed,
      resizeObserver: null,
      contentHeight: null,
    }
  },

  computed: {
    styleConfig() {
      let vPad = this.vPad;
      let hPad = this.hPad;
      if (this.size === 'big') {
        return {vPad: vPad || 24, hPad: hPad || 24, borderRadius: 24};
      } else /* small */ {
        return {vPad: vPad || 16, hPad: hPad || 12, borderRadius: 8};
      }
    },
    panelStyle() {
      let p = this.styleConfig;
      return {
        "box-shadow": "0 2px 4px #00000014",
        "background": "#FFFFFF 0 0 no-repeat padding-box",
        "border-radius": `${p.borderRadius}px`
      }
    },
    headerStyle() {
      let p = this.styleConfig;
      return {
        padding: `${p.vPad}px ${p.hPad}px`,
        cursor: this.collapsible ? 'pointer' : undefined
      }
    },
    contentStyle() {
      let p = this.styleConfig;
      return {
        padding: `0 ${p.hPad}px ${p.vPad}px`
      }
    },
    wrapperStyle() {
      return {
        height: this.isOpen && this.contentHeight ? `${this.contentHeight}px` : 0
      }
    }
  },

  mounted() {
    this.resizeObserver = new ResizeObserver(() => {
      this.contentHeight = this.$refs.content ? this.$refs.content.clientHeight : 0;
    });
    this.resizeObserver.observe(this.$refs.content);
  },

  watch: {
    collapsed(val) {
      this.isOpen = !val;
    }
  },

  methods: {
    close() {
      this.isOpen = false;
    },
    toggleCollapse() {
      this.isOpen = !this.collapsible || !this.isOpen;
      if (this.collapsible && this.isOpen) {
        this.$emit('opened');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content-wrapper {
  overflow: hidden;
  transition: height 200ms;
}
</style>